import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function PainSection() {
  const painPoints = ['😰 Berrinche en el supermercado y no sabés si quedarte o irte — improvisás y sale mal', '😔 Decís que no, él insiste, vos cedés — y después la culpa te aplasta por horas', '😢 Gritaste. Otra vez. Y el ciclo de culpa arranca de nuevo esa noche', '😤 Los abuelos dan lo que vos negás y el sistema se cae entero', '😳 Los berrinches en público te paralizan de vergüenza mientras todos miran', '😩 Llegás al final del día agotada y con miedo de que mañana sea igual o peor'];
  return <section className="py-20 md:py-28 bg-offwhite" data-id="element-222">
      <div className="container mx-auto px-4" data-id="element-223">
        <div className="max-w-3xl mx-auto" data-id="element-224">
          <SectionWrapper data-id="element-225">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-dark-green mb-8 text-center leading-tight" data-id="element-226">
              ¿Cuántos domingos más van a terminar así?
            </h2>

            <div className="prose prose-lg mx-auto mb-12 text-dark-green/80 font-poppins text-center" data-id="element-227">
              <p className="mb-4" data-id="element-228">
                Sos mamá. Amás a tu hijo con todo. Pero nadie te dijo que ibas a
                pasar los domingos —y los lunes, y las noches— sin saber qué
                hacer cuando explota, cediendo para que pare y sintiéndote
                pésima después.
              </p>
              <p className="text-terracotta font-bold text-xl mt-6" data-id="element-229">
                No es falta de amor. Es falta de un sistema.
              </p>
            </div>
          </SectionWrapper>

          <SectionWrapper delay={0.2} data-id="element-230">
            <div className="space-y-4 mb-14" data-id="element-231">
              {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4 p-5 rounded-xl bg-white shadow-sm border border-sage/10 hover:border-sage/30 hover:shadow-md transition-all" data-id="element-232">
                  <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-233">
                    {point.substring(0, 2)}
                  </span>
                  <p className="text-dark-green/90 font-poppins text-base md:text-lg" data-id="element-234">
                    {point.substring(2).trim()}
                  </p>
                </div>)}
            </div>
          </SectionWrapper>

          <SectionWrapper delay={0.4} data-id="element-235">
            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-sage" data-id="element-236">
              <p className="text-dark-green/90 font-poppins text-lg md:text-xl leading-relaxed italic" data-id="element-237">
                Criar no debería costarte tu salud mental ni tu paz. El problema
                no es tu paciencia. No es tu carácter. Es que nadie te enseñó
                qué hacer en los 90 segundos donde todo explota. Eso es
                exactamente lo que cambia hoy.
              </p>
            </div>
          </SectionWrapper>
        </div>
      </div>
    </section>;
}